import styles from '@components/icons/Icon.styles';
import theme from '@styles/theme';
import { TIcon } from '@components/icons/typescript';
import { iconComponentsMap } from '@components/icons/components';

type PropsType = {
  icon?: TIcon;
  color?: string;
  size?: string | string[];
  margin?: string;
  padding?: string;
  hover?: string;
  addSx?: unknown;
  cy?: string;
  children?: React.ReactNode;
  title?: string;
};

const Icon = ({
  icon = undefined,
  size = `${theme.fontSizes.text}px`,
  color = theme.rawColors.darkGrey700,
  margin = '0',
  padding = '0',
  hover = undefined,
  addSx = {},
  cy = undefined,
  children = undefined,
  title = '',
}: PropsType) => {
  const iconName = icon || '';
  const IconComponent = iconComponentsMap[iconName];
  return (
    <span
      sx={styles.icon({ size, color, margin, padding, hover }, addSx)}
      className={`icon ${iconName}`}
      data-cy={cy}
      title={title}
    >
      {IconComponent && <IconComponent />}
      {children}
    </span>
  );
};

export default Icon;
